import { toast } from "react-toastify";
import handleError from "./errorHandler";
import sendRequest from "./service";

interface DeleteModalParams {
  apiUrl: string;
  apiParams?: { [key: string]: any };
  modals?: Array<{
    title: string;
    message: string;
    type?: "parameter" | "info";
    parameterKey?: string;
    confirmButton: {
      text: string;
      color?: "red" | "black" | "gray" | "blue" | "green";
      value?: any;
    };
    cancelButton?: {
      text: string;
      color?: "red" | "black" | "gray" | "blue" | "green";
      value?: any;
    };
  }>;
  validateModal?: boolean;
  validationText?: string;
  successText?: string;
}

export default function openDeleteModal(params: DeleteModalParams, index = 0) {
  return new Promise((resolve) => {
    if (params.modals[index]) {
      resolve(showModal(params, index));
    }
  });
}

function showModal(params: DeleteModalParams, index: number) {
  return new Promise((resolve) => {
    const modal = params.modals[index];
    // @ts-ignore
    window.setModal({
      title: modal.title,
      message: modal.message,
      type: "warning",
      cancelButton: {
        text: modal.cancelButton.text,
        color: modal.cancelButton.color,
        onClick: () => {
          if (modal.type === "parameter") {
            if (!params.apiParams) params.apiParams = {};

            params.apiParams[modal.parameterKey] = modal.cancelButton.value;
            if (params.modals[index + 1]) {
              setTimeout(() => {
                resolve(openDeleteModal(params, index + 1));
              }, 0);
            } else if (params.validateModal) {
              setTimeout(() => {
                resolve(openValidationModal(params));
              }, 0);
            }
          } else {
            resolve(true);
          }
        },
      },
      confirmButton: {
        text: modal.confirmButton.text,
        color: modal.confirmButton.color,
        onClick: () => {
          if (modal.type === "parameter") {
            if (!params.apiParams) params.apiParams = {};

            params.apiParams[modal.parameterKey] = modal.confirmButton.value;
          }

          if (params.modals[index + 1]) {
            setTimeout(() => {
              resolve(openDeleteModal(params, index + 1));
            }, 0);
          } else if (params.validateModal) {
            setTimeout(() => {
              resolve(openValidationModal(params));
            }, 0);
          } else {
            // @ts-ignore
            window.setLoading(true);
            sendRequest
              .delete({ url: params.apiUrl })
              .finally(() => {
                // @ts-ignore
                window.setLoading(false);
              })
              .then((res) => {
                resolve(res);
                toast(params.successText || "Record deleted successfully", {
                  type: "success",
                  theme: "colored",
                });
              })
              .catch((error) => {
                console.log("@hata", error);
                resolve(false);
                handleError(error);
              });
          }
        },
      },
    });
  });
}

function openValidationModal(params) {
  return new Promise((resolve, reject) => {
    const validationText = params.validationText || "CONFIRM";

    // @ts-ignore
    window.setModal({
      title: "Validate Delete Request",
      message: `Please enter '<b>${validationText}</b>' to delete this record'`,
      type: "validation",
      validationText,
      confirmButton: {
        text: "Confirm",
        color: "red",
        onClick: () => {
          // @ts-ignore
          window.setLoading(true);
          sendRequest
            .delete({
              url: params.apiUrl,
              data: params.apiParams,
            })
            .then((res) => {
              resolve(res);
              toast(params.successText || "Record deleted successfully", {
                type: "success",
                theme: "colored",
              });
            })
            .catch((error) => {
              handleError(error);
              reject();
            })
            // @ts-ignore
            .finally(() => window.setLoading(false));
        },
      },
      cancelButton: {
        text: "Cancel",
        color: "black",
        onClick: reject,
      },
    });
  });
}
